/** @typedef {import("../../api/types").ProviderConfig} ProviderConfig */
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";
import {Alert, Container, Spinner} from "reactstrap";
import ResourceForm from "../resources/ResourceForm";
import {config} from "../resources/resources";

const {url, path, fields} = config;

// The provider config is a singleton: load the one entry the list returns
// and update it in place.
const ConfigEdit = () => {
    const navigate = useNavigate();
    const [current, setCurrent] = useState(/** @type {ProviderConfig|null} */ (null));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        axios
            .get(url, {signal: controller.signal})
            .then(({data}) => {
                const [first] = data.results ?? [];
                if (first) {
                    setCurrent(first);
                } else {
                    setError("Nenhuma configuração encontrada.");
                }
            })
            .catch((err) => {
                if (axios.isCancel(err)) return;
                setError("Não foi possível carregar as configurações.");
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        return () => controller.abort();
    }, []);

    return (
        <Container className="mt-4 mb-5" style={{maxWidth: 640}}>
            <Link to={path}>&larr; Voltar</Link>
            <h3 className="mt-3 mb-3">Editar configurações</h3>
            {loading && (
                <div className="text-center">
                    <Spinner />
                </div>
            )}
            {error && <Alert color="danger">{error}</Alert>}
            {current && (
                <ResourceForm
                    fields={fields}
                    initial={current}
                    submitLabel="Salvar alterações"
                    onCancel={() => navigate(path)}
                    onSubmit={async (payload) => {
                        await axios.put(`${url}${current.id}/`, payload);
                        navigate(path, {replace: true});
                    }}
                />
            )}
        </Container>
    );
};

export default ConfigEdit;
